import React from 'react'
import Permissions from 'services/Permissions'
import { Can } from '@morningtrain/react-auth'
import * as Displays from 'support/displays'
import { Form, SubmitFormOnPipe } from '@morningtrain/react-resources'
import { Pipeline, TriggerPipelineOnCallback } from '@morningtrain/react-pipelines'

export default function EditableAvatar ({ children }) {
  const callbackRef = React.useRef(null)

  const updateCallbackRef = (callback) => {
    callbackRef.current = callback
  }

  const handleFileChange = React.useCallback((e) => {
    if (callbackRef.current && typeof callbackRef.current === 'function') {
      callbackRef.current()
    }
  })

  return (
    <>
      <Can permission={Permissions.EMPLOYMENTS_MANAGE_USER_AVATAR}>
        <Form route='api.users.users.avatar_upload'>
          <label>
            <input
              className='hidden'
              name='avatar_upload'
              type='file'
              accept='image/*'
              onChange={handleFileChange}
            />
            <Displays.Image name='avatar_url' />
          </label>
          <Pipeline>
            <TriggerPipelineOnCallback callback={updateCallbackRef} />
            <SubmitFormOnPipe />
            {children}
          </Pipeline>
        </Form>
      </Can>
      <Can permission={Permissions.EMPLOYMENTS_MANAGE_USER_AVATAR} negate>
        <Displays.Image name='avatar_url' />
      </Can>
    </>
  )
}
